export const OVERLAPPING_TIME_MESSAGE = "Overlapping time";

/**
 * True when two ranges share any time. A shared endpoint does not count.
 * A missing end means the entry is still running.
 * Times are comparable numbers (milliseconds).
 */
export function intervalsOverlap(startA, endA, startB, endB) {
	if (startA == null || startB == null) return false;
	const aOpen = endA == null;
	const bOpen = endB == null;
	if (aOpen && bOpen) return true;
	if (aOpen) return endB > startA;
	if (bOpen) return endA > startB;
	return startA < endB && startB < endA;
}

/**
 * True when the proposed interval overlaps any candidate other than excludeTimesheetId.
 * Mirrors SafetywiseApi.Core.TimesheetOverlap.HasOverlapWithAny.
 */
export function hasOverlapWithAny(start, end, candidates, excludeTimesheetId = null) {
	if (!Array.isArray(candidates)) return false;
	return candidates.some((other) => {
		if (excludeTimesheetId != null && other.id === excludeTimesheetId) return false;
		return intervalsOverlap(start, end, other.start, other.end);
	});
}

/** Adds an overlap error to each row that shares time with another row for the same staff member. */
export function markOverlappingTimesheetRows(rows) {
	const byStaff = new Map();
	rows.forEach((row, index) => {
		if (row.startMs == null || row.endMs == null || !(row.endMs > row.startMs)) return;
		const key = row.staff ?? "";
		if (!byStaff.has(key)) byStaff.set(key, []);
		byStaff.get(key).push(index);
	});

	for (const indexes of byStaff.values()) {
		for (let i = 0; i < indexes.length; i++) {
			for (let j = i + 1; j < indexes.length; j++) {
				const a = rows[indexes[i]];
				const b = rows[indexes[j]];
				if (!intervalsOverlap(a.startMs, a.endMs, b.startMs, b.endMs)) continue;
				if (!a.ers.includes(OVERLAPPING_TIME_MESSAGE)) a.ers.push(OVERLAPPING_TIME_MESSAGE);
				if (!b.ers.includes(OVERLAPPING_TIME_MESSAGE)) b.ers.push(OVERLAPPING_TIME_MESSAGE);
			}
		}
	}

	return rows;
}
